const getNotificationPermission = () => {
  if (Notification.permission === "granted") {
    return localStorage.getItem("notification-permission") || "granted";
  }
  return Notification.permission;
};

export default getNotificationPermission;
